
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import SquiggleUnderline from "./SquiggleUnderline";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { useState } from "react";
import { useFavorites } from "@/contexts/FavoritesContext";
import { GEAR_CATEGORIES } from "@/lib/gearCategories";

type DesktopNavigationProps = {
  onOpenSearch: () => void;
};

const DesktopNavigation = ({ onOpenSearch }: DesktopNavigationProps) => {
  const [isExploreOpen, setIsExploreOpen] = useState(false);
  const { hasFavorites } = useFavorites();

  const handleCategoryClick = () => {
    setIsExploreOpen(false);
  };

  return (
    <nav className="hidden items-center space-x-8 lg:flex">
      <Link to="/" className="relative group text-base font-medium hover:text-primary transition-colors py-2">
        Home
        <SquiggleUnderline />
      </Link>

      <NavigationMenu value={isExploreOpen ? "explore" : ""} onValueChange={(value) => setIsExploreOpen(value === "explore")}>
        <NavigationMenuList>
          <NavigationMenuItem value="explore">
            <NavigationMenuTrigger className="relative group text-base font-medium hover:text-primary transition-colors py-2 bg-transparent hover:bg-transparent focus:bg-transparent data-[active]:bg-transparent data-[state=open]:bg-transparent">
              Explore
              <SquiggleUnderline />
            </NavigationMenuTrigger>
            <NavigationMenuContent>
              <div className="grid w-48 gap-1 p-2 bg-background border rounded-md shadow-lg">
                <Link
                  key={"all"}
                  to={`/explore`}
                  className="block px-3 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground rounded-sm transition-colors"
                  onClick={handleCategoryClick}
                >
                  All Equipment
                </Link>
                
                <Link
                  to="/explore?view=hybrid&myFavorites=true"
                  className={`block px-3 py-2 text-sm font-medium rounded-sm transition-colors ${
                    hasFavorites
                      ? 'hover:bg-accent hover:text-accent-foreground'
                      : 'text-muted-foreground cursor-not-allowed'
                  }`}
                  onClick={(e) => {
                    if (!hasFavorites) {
                      e.preventDefault();
                    } else {
                      handleCategoryClick();
                    }
                  }}
                >
                  My Favorites {!hasFavorites && '(empty)'}
                </Link>
                
                {GEAR_CATEGORIES.map((gear) => (
                  <Link
                    key={gear.slug}
                    to={`/explore?category=${gear.slug}`}
                    className="block px-3 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground rounded-sm transition-colors"
                    onClick={handleCategoryClick}
                  >
                    {gear.label}
                  </Link>
                ))}
              </div>
            </NavigationMenuContent>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>

      {/* <button
        onClick={handleListGearClick}
        className="relative group text-base font-medium hover:text-primary transition-colors py-2"
      >
        List Your Gear
        <SquiggleUnderline />
      </button> */}
      <Link to="/gear-quiz" className="relative group text-base font-medium hover:text-primary transition-colors py-2">
        Gear Quiz
        <SquiggleUnderline />
      </Link>
      <Link to="/demo-calendar" className="relative group text-base font-medium hover:text-primary transition-colors py-2">
        Demo Calendar
        <SquiggleUnderline />
      </Link>
      <Link to="/blog" className="relative group text-base font-medium hover:text-primary transition-colors py-2">
        Blog
        <SquiggleUnderline />
      </Link>
      <button
        className="relative group flex items-center text-base font-medium hover:text-primary transition-colors py-2"
        onClick={onOpenSearch}
      >
        <Search className="h-4 w-4 mr-2" />
        <span>Search</span>
        <SquiggleUnderline />
      </button>
    </nav>
  );
};

export default DesktopNavigation;
